import { render, staticRenderFns } from "./thumbs-rating.vue?vue&type=template&id=71b11d6e"
import script from "./thumbs-rating.vue?vue&type=script&lang=js"
export * from "./thumbs-rating.vue?vue&type=script&lang=js"
import style0 from "./thumbs-rating.vue?vue&type=style&index=0&id=71b11d6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports